export default __webpack_public_path__ + "static/media/cta.40782d56.jpg";